import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app.config.token';
import { CreateModMailDto, ModMailType } from '@bossanova/models';

@Injectable({ providedIn: 'root' })
export class ModMailService {
  private http = inject(HttpClient);
  private config = inject(APP_CONFIG);

  sendFeedback(payload: Omit<CreateModMailDto, 'type'>): Observable<void> {
    return this.http.post<void>(`${this.config.apiUrl}/mod-mail`, {
      ...payload,
      type: ModMailType.Feedback,
    });
  }
}
